export default __webpack_public_path__ + "static/media/gopay-logo.af2516ec.svg";